import * as yup from 'yup'

export const schema = yup.object({
    periodoInicial: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    periodoFinal: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    ufDetran: yup.string()
})
